// Mehryaa Global JavaScript
// Core functionality for the Shopify theme

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initializeTheme();
  });

  function initializeTheme() {
    console.log('Mehryaa theme initialized');
    
    // Mobile menu functionality
    initializeMobileMenu();
    
    // Cart functionality
    initializeCart();
    
    // Product functionality
    initializeProductForms();
    
    // Search functionality
    initializeSearch();
  }

  function initializeMobileMenu() {
    const mobileToggle = document.getElementById('mobile-nav-toggle');
    const mobileMenu = document.getElementById('mobile-menu');
    
    if (mobileToggle && mobileMenu) {
      // Show mobile toggle on small screens
      function checkScreenSize() {
        if (window.innerWidth <= 768) {
          mobileToggle.style.display = 'block';
        } else {
          mobileToggle.style.display = 'none';
          mobileMenu.style.display = 'none';
        }
      }
      
      checkScreenSize();
      window.addEventListener('resize', checkScreenSize);
    }
  }

  function initializeCart() {
    // Update cart count display
    updateCartCount();
    
    // Add to cart forms
    const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
    
    addToCartForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        const submitButton = form.querySelector('button[type="submit"]');
        
        if (submitButton) {
          const originalText = submitButton.textContent;
          submitButton.textContent = 'Adding...';
          submitButton.disabled = true;
          
          // Re-enable after 2 seconds
          setTimeout(() => {
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }, 2000);
        }
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
          element.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }

  function initializeProductForms() {
    // Variant selection
    const variantSelectors = document.querySelectorAll('select[name*="option"]');
    
    variantSelectors.forEach(select => {
      select.addEventListener('change', function() {
        updateProductVariant();
      });
    });
  }

  function updateProductVariant() {
    // Get selected options
    const options = [];
    const optionSelectors = document.querySelectorAll('select[name*="option"]');
    
    optionSelectors.forEach(select => {
      options.push(select.value);
    });
    
    // Update hidden variant selector
    const variantSelector = document.querySelector('select[name="id"]');
    if (variantSelector) {
      const variants = Array.from(variantSelector.options);
      const matchingVariant = variants.find(option => {
        const variantTitle = option.text.split(' - ')[0];
        return options.every(selectedOption => variantTitle.includes(selectedOption));
      });
      
      if (matchingVariant) {
        variantSelector.value = matchingVariant.value;
      }
    }
  }

  function initializeSearch() {
    // Search form functionality
    const searchForms = document.querySelectorAll('form[action*="/search"]');
    
    searchForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        const searchInput = form.querySelector('input[name="q"]');
        if (searchInput && searchInput.value.trim() === '') {
          e.preventDefault();
          searchInput.focus();
        }
      });
    });
  }

  // Utility functions
  window.Mehryaa = window.Mehryaa || {};
  
  window.Mehryaa.formatMoney = function(cents, format) {
    if (!format) format = '₹{{amount}}';
    
    const value = cents / 100;
    const formattedValue = value.toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    
    return format.replace('{{amount}}', formattedValue);
  };
  
  window.Mehryaa.addToCart = function(variantId, quantity = 1) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    
    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(item => {
      updateCartCount();
      return item;
    });
  };
  
  window.Mehryaa.updateCart = function(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => response.json())
    .then(cart => {
      updateCartCount();
      return cart;
    });
  };

})();